import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_tettamanti from "../../assets/img/face_tamas_tettamanti.jpg";
import ShowMoreText from "react-show-more-text";
import proj_spatio_temporal_impact_assessment from "../../assets/img/proj_spatio_temporal_impact_assessment.png";

const T_Tettamanti_waze = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_spatio_temporal_impact_assessment} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_tettamanti}
              /* this will be the text on the banner */
              alt="Spatio-temporal impact assessment of accidents/ road closures based on WAZE data"
            />{" "}
            <p className="text7">Tamás Tettamanti</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The task is to carry out the spatio-temporal impact assessment of road traffic incidents 
            (accidents, road closures). For the project work, full historical WAZE data from Budapest 
            is provided via the Waze Traffic Data Analyser web application (<a href="https://trafmine.com/">webservice</a> is provided). 
            The student must find spatial and temporal relationships among incidents if exist at all, 
            i.e., what is the probability of a given incident cause a further accident (where and when)? 
            In all, the main goal is to look for statistical relationships among the appearance of incidents 
            (e.g., revealing chain of incidents).
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://ieeexplore.ieee.org/document/10225424">Varga, Balázs; Tettamanti, 
                Tamás: Jam Propagation Analysis With Mesoscopic Traffic Simulation, In: IEEE Transactions on 
                Intelligent Transportation Systems, pp. 1-12, 2023,</a>
                </li>
                <li>
                <a href="https://www.witpress.com/Secure/elibrary/papers/UG18/UG18022FU1.pdf">Kisgyörgy, Lajos ; Szele, András: 
                Traffic operation on a road Network with recurrent congestion, In: S., Syngellakis; J., 
                Melgarejo (szerk.) WIT Transactions on The Built Environment : Urban Growth 2018, Alicante, 
                Spanyolország : WIT Press (2018) 416 p. pp. 233-243. , 11 p.</a>
                </li>
            </ul>
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default T_Tettamanti_waze;